/**
 * Port of cdc-web `src/utils/oddsFormat/index.ts` 的 percentage 分支。
 * cdc-market 决策：prediction 卡片只做 percentage 展示（无 American odds 切换），
 * 所以 PriceCell 直接用本函数，不走 useOddsFormat。
 *
 * `p` 是 0–1 小数概率（`contract.yes` / `contract.no`），输出整数百分比。
 */
export function formatPercentage(p: string | number | null | undefined): string {
  const num = Number(p)
  if (p === null || p === undefined || p === '' || Number.isNaN(num)) {
    return '-%'
  }
  return `${Math.round(num * 100)}%`
}
